import { AuthenticatedUser } from '@gettactic/api';
import { USE_ONLY_LOCAL_STORAGE_FOR_DS } from './hooks/useGetAuthenticatedUser';
import { isTacticAppWebView } from './isTacticAppWebView';

export function isDesignSystem2(
  authenticatedUser?: AuthenticatedUser | null,
  settingsVersion?: string
) {
  const isMobileWebView = isTacticAppWebView();
  if (isMobileWebView) return true;
  const ds = getDesignSystemVersion(authenticatedUser);

  if (authenticatedUser?.user?.is_being_impersonated) {
    // check only local storage for impersonated users
    return getLocalDesignSystemVersion() === 'v2';
  }
  if (ds === null) {
    return settingsVersion === 'v2';
  }
  return ds === 'v2';
}

export function getLocalDesignSystemVersion() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  try {
    return localStorage.getItem('designSystemVersion');
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return 'v1';
  }
}

export function getDesignSystemVersion(
  authenticatedUser?: AuthenticatedUser | null
) {
  if (USE_ONLY_LOCAL_STORAGE_FOR_DS) {
    const ds = getLocalDesignSystemVersion();
    return ds;
  }
  return 'v1';
}
